import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CoreInputComponent } from '@shared/components/core-input/core-input.component';
import { CoreSelectComponent } from '@shared/components/core-select/core-select.component';
import { CoreButtonComponent } from '@shared/components/core-button/core-button.component';
import { AppIcons } from '@core/utilities/icons';
import { PersonasAuthService } from '../services/personas-auth.service';
import {
    CatalogOption,
    PersonasCatalogsService
} from '../services/personas-catalogs.service';

@Component({
    selector: 'app-ingreso',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        CoreInputComponent,
        CoreSelectComponent,
        CoreButtonComponent
    ],
    templateUrl: './ingreso.component.html',
    styleUrls: ['./ingreso.component.scss']
})
export class IngresoComponent implements OnInit {
    private fb = inject(FormBuilder);
    private authService = inject(PersonasAuthService);
    private catalogsService = inject(PersonasCatalogsService);
    private router = inject(Router);

    readonly icons = AppIcons;

    isLoading = false;
    errorMessage = '';

    form: FormGroup = this.fb.group({
        document_type_id: [null, Validators.required],
        document: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.maxLength(12)]]
    });

    docTypes: { name: string; id: string }[] = [];

    ngOnInit(): void {
        this.loadDocumentTypes();
    }

    onSubmit() {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.isLoading = true;
        this.errorMessage = '';

        const { document_type_id, document } = this.form.value;

        this.authService.checkActiveCredit(document_type_id, document)
            .subscribe({
                next: () => {
                    this.isLoading = false;
                    this.router.navigateByUrl('/personas/ingreso/verificacion');
                },
                error: (err) => {
                    this.isLoading = false;
                    this.errorMessage = err.message || 'No se encontró un crédito activo con estos datos.';
                }
            });
    }

    private loadDocumentTypes() {
        this.catalogsService.getDocumentTypes().subscribe({
            next: (documentTypes) => {
                this.docTypes = this.mapDocumentTypes(documentTypes);
                const preferredDocumentType = this.docTypes.find((item) => item.id === 'CC')?.id
                    ?? this.docTypes[0]?.id
                    ?? null;
                this.form.patchValue({ document_type_id: preferredDocumentType });
            },
            error: (err) => {
                this.errorMessage = err.message || 'No pudimos cargar los tipos de documento.';
            }
        });
    }

    private mapDocumentTypes(options: CatalogOption[]) {
        return options.map((option) => ({
            name: option.name,
            id: option.alias || String(option.id)
        }));
    }
}
